import http from "../http-common";
import authHeader, {authHeaderMultipart} from './auth-header';

class UsuariosDataService {

  getAllPaginated(page, size, sortName, sortOrder) {
    return http.get("/api/usuarios/todos", {
      headers: authHeader(),
      params: {page: page, size: size, sortName: sortName, sortOrder: sortOrder}
    });
  }
  
  filter(term, page, size, sortName, sortOrder) {
    return http.get("/api/usuarios/filtra", {
      headers: authHeader(),
      params: {term: term, page: page, size: size, sortName: sortName, sortOrder: sortOrder}
    });
  }

  getUsuario(idUsuario) {
    return http.get("/api/usuarios/" + idUsuario, { headers: authHeader() });
  }

  createUsuario(entity){
    return http.post("/api/usuarios", entity, { headers: authHeader() });
  }

  updateUsuario(entity){
    return http.put("/api/usuarios", entity, { headers: authHeader() });
  }

  toggleActivo(idUsuario) {
    return http.put(`/api/usuarios/${idUsuario}/toggle-activo`, {}, { headers: authHeader() });
  }

  getProfile(codigoUsuario) {
    return http.get("/api/usuarios/profile", {headers: authHeader(), params: {codigoUsuario: codigoUsuario}});
  }

  getFirma(codigoUsuario) {
    return http.get("/api/usuarios/firma", {
      headers: authHeader(),
      responseType: 'blob',
      params: {codigoUsuario: codigoUsuario}
    });
  }

  uploadFirma(codigoUsuario, data) {
    return http.post("/api/usuarios/firma", data, {
      headers: authHeaderMultipart(),
      params: {codigoUsuario: codigoUsuario}
    });
  }

  changePwd(login, password, newPassword) {
    return http.post("/api/usuarios/changepwd", { login, password, newPassword }, { headers: authHeader() });
  }
}

export default new UsuariosDataService();